var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-license-tag tag pointer",class:{ 'is-warning': !_vm.device.license },on:{"click":_vm.handleLicenseManage}},[_vm._v(" "+_vm._s(_vm.device.license ? _vm.device.license.product.name : 'Unlicensed')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }